import styled, {css} from 'styled-components';
import {CursorCircleWhite, CursorCircleBlack} from 'shared/Styles/Cursors';

export const ColorPageContainer = styled.div`
    position: relative;
    background-color: ${({pageColor}) => (pageColor ? pageColor : '#CFE9FF')};
    width: 100%;
    ${props => (props.cursorWhite ? CursorCircleWhite : CursorCircleBlack)}
`;

export const ContentContainer = styled.div`
    padding-top: 170px;
    ${({paddingContact}) =>
            paddingContact &&
            css`
                padding-top: 270px;
            `}
    padding-bottom: 340px;
    margin: 0 auto;
    max-width: 780px;
    @media screen and (max-width: 1400px) {
        padding-bottom: 260px;
    }
    @media screen and (max-width: 1200px) {
        padding-bottom: 250px;
    }
    @media screen and (max-width: 992px) {
        padding-bottom: 190px;
    }
    @media screen and (max-width: 767px) {
        padding-bottom: 240px;
        max-width: 90%;
    }
    @media screen and (max-width: 576px) {
        padding-bottom: 200px;
    }
`;

export const PhotosContainer = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 150px;
    padding: 0 170px;
    padding-bottom: 400px;
    @media screen and (max-width: 992px) {
        margin-top: 150px;
        padding: 0 100px;
        padding-bottom: 400px;
    }
    @media screen and (max-width: 767px) {
        margin-top: 100px;
        padding: 0 60px;
        padding-bottom: 300px;
    }
    @media screen and (max-width: 576px) {
        margin-top: 60px;
        padding: 0 30px;
        padding-bottom: 200px;
    }
`;
export const ImageContainer = styled.div`
    display: flex;
    justify-content: ${({flexJustify}) =>
            flexJustify ? flexJustify : 'flex-start'};
    margin-bottom: 100px;

    .gatsby-image-wrapper {
        width: 60%;
        height: 100%;
    }

    @media screen and (max-width: 1240px) {
        display: block;
        .gatsby-image-wrapper {
            width: 100%;
            height: 100%;
        }
    }
`;
export const AudiobookContainer = styled.div`
    margin-bottom: 50px;
`;
export const VideoContainer = styled.div`
    position: relative;
    padding: 0 30px 300px 30px;
    height: 700px;
    @media screen and (max-width: 1400px) {
        padding-bottom: 260px;
    }
    @media screen and (max-width: 1200px) {
        padding-bottom: 250px;
    }
    @media screen and (max-width: 992px) {
        padding-bottom: 300px;
    }
    @media screen and (max-width: 767px) {
        padding-bottom: 440px;
        height: 300px;
    }
    @media screen and (max-width: 576px) {
        padding-bottom: 400px;
    }
`;
export const Video = styled.iframe`
    position: absolute;
    top: 0%;
    height: 100%;
    width: 100%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
    max-width: 1140px;
`;
